const map = {
	"./bike-generic.svg": 26343,
	"./bus-generic.svg": 98762,
	"./car-generic.svg": 16010,
	"./cargo-bike-generic.svg": 31562,
	"./cargo-ebike-generic.svg": 77757,
	"./delivery-robot-generic.svg": 85527,
	"./pedestrian-generic.svg": 9531,
	"./scooter-generic.svg": 84341,
	"./seated-scooter-generic.svg": 30578,
	"./truck-generic.svg": 1977
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65422;